/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Consent_RequiredInputs */

const en_signup_consent_required = /** @type {(inputs: Signup_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please tick the boxes above to continue.`)
};

const pl_signup_consent_required = /** @type {(inputs: Signup_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaznacz powyższe pola, aby kontynuować.`)
};

/**
* | output |
* | --- |
* | "Please tick the boxes above to continue." |
*
* @param {Signup_Consent_RequiredInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const signup_consent_required = /** @type {((inputs?: Signup_Consent_RequiredInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Consent_RequiredInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_signup_consent_required(inputs)
	return en_signup_consent_required(inputs)
});